import api from './api';

const BASE = '/api/feature-design-studio';

export const featureDesignStudioApi = {
  generate({ requirement_text, feature_title }) {
    return api.post(`${BASE}/generate`, { requirement_text, feature_title }).then((res) => res.data);
  },
  refine({ draft, user_instruction, task_temp_id }) {
    return api
      .post(`${BASE}/refine`, { draft, user_instruction, task_temp_id })
      .then((res) => res.data);
  },
  buildTasks({ draft, project_id, feature_tag_id }) {
    return api
      .post(`${BASE}/build-tasks`, { draft, project_id, feature_tag_id })
      .then((res) => res.data);
  }
};
